import documentApiClient, { ApiDefinition } from '@documentsApi';
import buildPath from '@tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/document-request-users/user-workflows/{userWorkflowId}']['GET'];
type Input = ThisApi['query'] & ThisApi['params'];

const getDocumentRequestUsersForUserWorkflow = async ({ userWorkflowId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.get(buildPath<ThisApi>('/document-request-users/user-workflows/{userWorkflowId}', { userWorkflowId }));
  return response.data;
};

export default getDocumentRequestUsersForUserWorkflow;